import { tv } from '~/utils/tv'

export const InputMultiSelectFieldVariants = tv({
  base: `
    peer/field h-small flex w-[100%] bg-[transparent] !font-rdmodern font-regular text-text-neutral-alternative tracking-tiny leading-small
    placeholder:opacity-transparent focus-visible:border-none focus-visible:outline-none
  `,
  variants: {
    size: {
      md: 'text-threepulse',
      ml: 'text-threeandhalfpulse',
      lg: 'text-threeandhalfpulse',
      xl: 'text-threeandhalfpulse',
    },
    readOnly: {
      true: 'text-text-neutral-readonly',
    },
    disabled: {
      true: 'cursor-not-allowed text-text-neutral-disabled',
      false: '',
    },
    isActive: {
      true: 'text-text-neutral',
    },
  },
  compoundVariants: [
    {
      readOnly: true,
      disabled: false,
      class: 'cursor-not-allowed text-text-neutral-readonly',
    },
  ],
  defaultVariants: {
    readOnly: false,
    disabled: false,
  },
})
